import "./App.scss";
import Inventory from "./Component/Inventory/Inventory";

function App() {
  return (
    <div className="app-wrap">
      <Inventory />
    </div>
  );
}

export default App;
